import { Module, Mutation, Action } from 'vuex-module-decorators'
import { SystemParameter, systemParameterApi } from '@/api'
import BaseStore from '@/store/BaseStore'

@Module({
  name: 'GlobalSystemParameterStore',
  namespaced: true,
  stateFactory: true
})
export default class GlobalSystemParameterStore extends BaseStore {
  items: SystemParameter[] = []

  get all(): SystemParameter[] {
    return this.items
  }

  get findByCodeKey() {
    return (codeKey: string) => {
      return this.items.find(item => item.codeKey === codeKey)
    }
  }

  @Mutation
  public setItems(systemParameters: SystemParameter[] = []) {
    this.items = systemParameters
  }

  @Action
  public async fetchAllByCodeKeys(codeKeys: string[]) {
    if (codeKeys.length === 0) {
      this.setItems([])
      return
    }

    const responses = await systemParameterApi.getSystemParameters({
      codeKey: '',
      codeKeys,
      code: ''
    })

    this.setItems(responses)
  }
}
